import SEO from '@/components/base/SEO';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <SEO title="关于我们 - 番号大全" description="番号大全品牌介绍、口碑评价与联系方式" />
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-secondary-100 rounded-2xl">
          <i className="ri-information-line text-secondary-500 text-2xl"></i>
        </div>
        <h2 className="font-heading text-xl font-semibold text-foreground-800 mb-2">关于我们</h2>
        <p className="text-sm text-foreground-500">即将上线，敬请期待</p>
      </div>
    </div>
  );
}